export const useDetailConfigOverrider = () => {

    const overrideDetailFields = function (originalData, corrections) {
        const clonedData = structuredClone(originalData);

        corrections.tabs.forEach((correctionTab, tabIndex) => {
            correctionTab.fieldsets.forEach((correctionFieldset, fieldsetIndex) => {
                Object.keys(correctionFieldset.fields).forEach((fieldKey) => {
                    const fieldValue = correctionFieldset.fields[fieldKey];
                    const targetFields = clonedData.tabs[tabIndex].fieldsets[fieldsetIndex].fields;

                    if (fieldValue === false) {
                        delete targetFields[fieldKey];
                    } else {
                        targetFields[fieldKey] = fieldValue;
                    }
                });
            });
        });

        return clonedData;
    }
    
    return {
        overrideDetailFields
    }
};
